export const FOCUS_RING_SHADOW = '0 0 0 2px #0000ee, 0 0 0 6px rgba(0, 0, 238, 0.15)';
